(<template>
  <section class="manager-section">
    <div class="manager-section__wrapper">
      <p class="manager-section__title">{{ sectionConfig.title }}</p>
      <div class="manager-section__contacts">
        <span class="sk-link manager-section__contact"
              v-html="sectionConfig.email"></span>
        <span class="sk-link manager-section__contact"
              v-html="projectManager.phone || sectionConfig.phone"></span>
      </div>
    </div>
  </section>
</template>)

<script>
  import {mapGetters} from 'vuex';

  export default {
    computed: {
      ...mapGetters('UserInfoStore', ['currentProvider']),
      ...mapGetters('OneProjectStore', ['projectManager']),
      sectionConfig() {
        const config = {title: 'Din prosjektleder', managerName: 'William Ransby'};
        return {...config, ...{email: this.email, phone: this.phone}};
      },
      phone() {
        const template = this.$gettext('Tel: <a href="tel:%{tel}" class="js-copy-to-clipboard">%{tel}</a>');
        return this.$gettextInterpolate(template, {tel: this.getTrimmedNumber});
      },
      getTrimmedNumber() {
        return this.$getString('domainData', 'supportTranslationPhone').replace(/ /g, '');
      },
      email() {
        const template = this.$gettext('Email: <a href="mailto:%{email}" class="js-copy-to-clipboard">%{email}</a>');
        return this.$gettextInterpolate(template, {email: this.$getString('domainData', 'supportTranslationEmail')});
      },
    }
  };
</script>

<style scoped>
  .manager-section__wrapper {
    display: flex;
    flex-wrap: wrap;
    padding: 10px;
    border-radius: 4px;
    background-color: var(--cool-gray-50);
  }

  .manager-section__title {
    width: 100%;
    padding-bottom: 5px;
    color: #333;
    font-weight: bold;
    font-size: 14px;
    text-align: center;
  }

  .manager-section__contacts {
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-width: 70%;
    padding-left: 10px;
  }

  .manager-section__contact {
    font-size: 13px;
  }
</style>
